import { logger } from '@/lib/logger';

let initialized = false;

export function initGlobalErrorHandlers(): void {
  if (initialized) return;
  initialized = true;

  window.addEventListener('error', (event: ErrorEvent) => {
    // Ignore ResizeObserver errors — benign and frequent
    if (event.message?.includes('ResizeObserver')) return;

    logger.error('[Global] Unhandled error:', event.message, event.filename, event.lineno);
  });

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    const message =
      reason instanceof Error
        ? reason.message
        : typeof reason === 'string'
          ? reason
          : 'Unknown rejection';

    logger.error('[Global] Unhandled promise rejection:', message);
  });
}
